import React, { Component } from "react";
import {  Modal, Form, Comment, Button, Segment, Feed, Icon } from 'semantic-ui-react'
import { invokeApig } from "../libs/awsLib";
import { formatDateTime, formatDate } from "../libs/sharedFunctions";
import './Comments.css';
import config from "../config";
import UserAvatar from './UserAvatar.js';


export default class MessageHistory extends Component {
  constructor(props) {
    super(props);
    this.state={history: [], historyLoaded: false};

  }

  loadHistory=(messageid)=>{
    //get function definition    
    this.setState({ eventLoaded: false})
    invokeApig({path: "/messages/" + messageid + "/heldhistory", method: "GET",  body: null}).then((result)=>
    {
      this.setState({history: result.data, historyLoaded: true})
    })
  }

  async componentDidMount() {
    this.loadHistory(this.props.messageid)
  }

  async componentWillReceiveProps(nextProps) {
  
    if (!(nextProps.messageid === this.props.messageid)) 
    {
      this.loadHistory(nextProps.messageid);
    } 
  }

  summaryRender(history){
    var summary='';
    if (history.action==='created'){
      summary=(<Feed.Summary style={{color: this.props.darkmode ? "white": "black"}}>
      <Feed.User style={{color: this.props.darkmode ? "white": "black"}}>{history.username}</Feed.User> {history.username ? ' created message' : 'Messsage created'}
      <Feed.Date style={{color: this.props.darkmode ? "white": "black"}}>  
        <div>{formatDateTime(new Date(history.datetime))}</div> 
      </Feed.Date>
      </Feed.Summary>)

    }
    else if(history.action==='held'){
      summary=(<Feed.Summary style={{color: this.props.darkmode ? "white": "black"}}>
        <Feed.User style={{color: this.props.darkmode ? "white": "black"}}>{history.username}</Feed.User> set message to {history.status} to be released on {formatDate(new Date(history.scheduledreleasedatetime))}
        <Feed.Date style={{color: this.props.darkmode ? "white": "black"}}>  
          <div>{formatDateTime(new Date(history.datetime))}</div> 
        </Feed.Date>
        </Feed.Summary>)
    }
    else{
      summary=(<Feed.Summary style={{color: this.props.darkmode ? "white": "black"}}>
        <Feed.User style={{color: this.props.darkmode ? "white": "black"}}>{history.username}</Feed.User> released the message
        <Feed.Date style={{color: this.props.darkmode ? "white": "black"}}>  
          <div>{formatDateTime(new Date(history.datetime))}</div> 
        </Feed.Date>
        </Feed.Summary>)

    }

    return summary
  }


  render() {
    return (
      <Feed> 
      {this.state.history.map((history)=>
        <Feed.Event>
        <Feed.Label>
          <Icon name={history.action==='created' ? 'add circle' : history.action==='held' ? 'pause circle' : 'play circle'} />
        </Feed.Label>
        {/* <Feed.Label><UserAvatar commentuserid={34} stage={config.stage} username={history.username ? history.username : ' '} userid={this.props.userid}/></Feed.Label> */}
          <Feed.Content>
          {this.summaryRender(history)}
            <Feed.Extra text>{history.comment}</Feed.Extra>
          </Feed.Content>
        </Feed.Event>
      )}
      </Feed>
    )
  }
}

